import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiInstagram, FiArrowUpRight, FiZap } = FiIcons;

const LiveDemoCard = () => {
  const { t, lang } = useLanguage();
  const demo = t.liveDemo;
  const INSTAGRAM_URL = "https://www.instagram.com/mathiasmazeedeppe/";
  const KEYWORD = lang === 'en' ? 'SYSTEM' : 'SISTEMA';

  return (
    <section className="py-12 px-6 bg-zinc-950">
      <div className="max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }}
          className="relative group"
        >
          {/* Animated Glow Border */}
          <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-500 to-orange-600 rounded-[2.5rem] blur opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-200 animate-pulse" />
          
          <div className="relative bg-zinc-900 border border-white/10 rounded-[2.5rem] p-8 md:p-12 overflow-hidden">
            {/* Background Decoration */}
            <div className="absolute top-0 right-0 -mt-8 -mr-8 w-48 h-48 bg-orange-500/10 blur-[80px] rounded-full pointer-events-none" />
            
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 relative z-10">
              {/* Icon / Visual Side */}
              <div className="shrink-0">
                <div className="w-24 h-24 md:w-32 md:h-32 bg-orange-500 rounded-3xl flex items-center justify-center shadow-[0_0_40px_rgba(249,115,22,0.4)] transform -rotate-3 group-hover:rotate-0 transition-transform duration-500">
                  <SafeIcon icon={FiInstagram} className="text-5xl md:text-6xl text-white" />
                </div>
              </div>

              {/* Content Side */}
              <div className="flex-1 text-center md:text-left">
                <div className="flex items-center justify-center md:justify-start gap-2 mb-4">
                  <span className="px-3 py-1 bg-orange-500/10 border border-orange-500/20 text-orange-500 text-[10px] font-black tracking-widest uppercase rounded-full flex items-center gap-1.5">
                    <SafeIcon icon={FiZap} className="text-xs" />
                    Live Proof
                  </span>
                </div>
                <h2 className="text-3xl md:text-4xl font-black text-white mb-4 tracking-tighter uppercase">
                  {demo.title}
                </h2>
                <p className="text-zinc-400 text-lg leading-relaxed mb-8">
                  {demo.body.split(KEYWORD).map((part, i, arr) => (
                    <React.Fragment key={i}>
                      {part}
                      {i < arr.length - 1 && (
                        <span className="text-white font-black bg-white/10 px-2 py-0.5 rounded-md border border-white/20 mx-1">
                          "{KEYWORD}"
                        </span>
                      )}
                    </React.Fragment>
                  ))}
                </p>
                <div className="flex flex-col items-center md:items-start gap-4">
                  <a 
                    href={INSTAGRAM_URL} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center gap-3 px-8 py-4 bg-white text-zinc-950 font-black rounded-full hover:bg-orange-500 hover:text-white transition-all transform hover:scale-105 shadow-xl group/btn"
                  >
                    {demo.cta}
                    <SafeIcon icon={FiArrowUpRight} className="text-xl group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1 transition-transform" />
                  </a>
                  
                  {/* Hub Link */}
                  <Link to="/ai-lead-agent" className="text-orange-500 hover:text-orange-400 text-sm font-semibold mt-4 block transition-colors">
                    {t.hub.liveProof}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LiveDemoCard;